import {motion} from "framer-motion";
import {useState} from "react";
import {handleSendEmail} from '../email.send';


export function AccessBtnComponent({text, className, onClick}: {
    text?: string,
    className?: string,
    onClick?: () => void
}) {
    const [isHovering, setIsHovering] = useState(false);

    const [mousePos, setMousePos] = useState({x: 0, y: 0});

    const handleMouseMove = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        const rect = e.currentTarget.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        setMousePos({x, y});
    };

    return (
        <motion.button
            className={className || "relative mt-6 px-6 py-3 bg-blue-500 rounded-lg text-white text-lg font-semibold overflow-hidden focus:outline-none border-0 "}
            style={{
                background: isHovering
                    ? `radial-gradient(
              circle at ${mousePos.x}px ${mousePos.y}px,
              rgba(265, 85, 247, 0.8),
              rgba(37, 99, 235, 0.1) 80%
            ), transparent` // #3b82f6 = bg-blue-500 (Tailwind)
                    : className ? '' : "#f63b9f",
                transition: "background 0.1s",
            }}
            onMouseEnter={() => setIsHovering(true)}
            onMouseLeave={() => setIsHovering(false)}
            onMouseMove={handleMouseMove}
            whileHover={{scale: 1.05}}
            whileTap={{scale: 0.95}}
            onClick={() => onClick ? onClick() : handleSendEmail({subject: 'Art development contact'})}
        >
            {text || ""}
        </motion.button>
    );
}
